import {
    REQUEST_START,
    REQUEST_LOAD,
    REQUEST_END,
    REQUEST_ERROR
} from '../actions/lookup-action';

export const lookup = (lookupItems = {}, action) => {
    switch (action.type) {
        case REQUEST_START:
            return Object.assign({}, lookupItems, { [action.name] : Object.assign({}, lookupItems[action.name], { isFetching: true, items: [], hasError: false, error: ''}) });
        case REQUEST_LOAD:
            const items = action.items ? action.items : [];
            return Object.assign({}, lookupItems, { [action.name] : Object.assign({}, lookupItems[action.name], { items: items }) });
        case REQUEST_ERROR:
            return Object.assign({}, lookupItems, { [action.name] : Object.assign({}, lookupItems[action.name], { items: [], hasError: true, error: action.error }) });
        case REQUEST_END:
            return Object.assign({}, lookupItems, { [action.name] : Object.assign({}, lookupItems[action.name], { isFetching: false }) });
        default :
            return lookupItems;
    }
}